var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndustryWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7711 4H15.3938C15.2587 4 15.1457 4.11297 15.1457 4.24816V9.42462C15.1457 9.60488 14.9427 9.7407 14.7846 9.65057L9.59572 7.09978C9.41549 7.00965 9.23464 7.14484 9.23464 7.32572V9.08572C9.23464 9.26598 9.03157 9.40179 8.87355 9.31167L4.36108 7.09981C4.18086 7.00968 4 7.14487 4 7.32576V19.7518C4 19.887 4.11296 20 4.24811 20H19.7491C19.8842 20 19.9972 19.887 19.9972 19.7518V4.32982C19.9972 4.27551 20.0072 4.21999 19.9944 4.16719C19.9712 4.07072 19.8781 4 19.7711 4ZM9.34684 15.2156C9.34684 15.3508 9.23389 15.4637 9.09873 15.4637H5.98547C5.85031 15.4637 5.73736 15.3508 5.73736 15.2156V13.2075C5.73736 13.0723 5.85031 12.9593 5.98547 12.9593H9.09938C9.23454 12.9593 9.34749 13.0723 9.34749 13.2075L9.34684 15.2156ZM14.8753 15.2156C14.8753 15.3508 14.7623 15.4637 14.6272 15.4637H11.5133C11.3781 15.4637 11.2652 15.3508 11.2652 15.2156V13.2075C11.2652 13.0723 11.3781 12.9593 11.5133 12.9593H14.6272C14.7623 12.9593 14.8753 13.0723 14.8753 13.2075V15.2156Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndustryWhite);
export default __webpack_public_path__ + "static/media/industry-white.c9502bedcc16302b985fde430b4bfbf3.svg";
export { ForwardRef as ReactComponent };